import { makeBaseEntitiesState, makeDefaultEntitiesState } from '@modules/app-common/state/entities.state';
import { CareerThread, FindCareerThreadsGQL, SchemaIntrospectionGQL } from 'generated/graphql';
import { Action, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

export class CareerThreadsFindManyAction {
  static readonly type = '[Career Threads] Find Many';

  constructor() {}
}

export class CareerThreadsSchemaIntrospectionAction {
  static readonly type = '[Career Threads] Schema Introspection';
}

const CareerThreadsBaseEntitiesState = makeBaseEntitiesState<CareerThread>('careerThreads');

@State({
  name: 'careerThreads',
  defaults: makeDefaultEntitiesState(),
})
@Injectable()
export class CareerThreadsEntitiesState extends CareerThreadsBaseEntitiesState {
  schemaIntrospectionGQL = inject(SchemaIntrospectionGQL);
  findCareerThreadsGQL = inject(FindCareerThreadsGQL);

  @Action(CareerThreadsFindManyAction)
  find(ctx: StateContext<any>, action: CareerThreadsFindManyAction): Observable<any> {
    return this.findCareerThreadsGQL.fetch({}, { fetchPolicy: 'no-cache' }).pipe(
      tap((result) => {
        this.patchEntities(ctx, result.data.findCareerThreads as CareerThread[]);
      })
    );
  }

  // @Action(CareerThreadsSchemaIntrospectionAction)
  // schemaIntrospection(ctx: StateContext<any>, action: CareerThreadsSchemaIntrospectionAction) {
  //   return this.schemaIntrospectionGQL.fetch({ entityName: 'CareerThread' }).pipe(
  //     tap((result) => {
  //       this.patchSchema(ctx, result.data.__type);
  //     })
  //   );
  // }
}
